import { render, staticRenderFns } from "./PeriodosElecCuotas.vue?vue&type=template&id=00525753&"
import script from "./PeriodosElecCuotas.vue?vue&type=script&lang=js&"
export * from "./PeriodosElecCuotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports